import React from 'react';
import moment from 'moment';
import CircularIndicator from '../common/indicators/circularIndicator';

const colorCircular = risk => {
  const obj = {
    higherRisk: [],
    middleRisk: [],
    outOfRisk: []
  };
  
  if(risk==null) {
    obj.outOfRisk.push(-1, -1);
    obj.middleRisk.push(-1, -1);
    obj.higherRisk.push(-1, -1);    
  }
  else if (risk.toUpperCase() === 'OUTOFRISK') {
    obj.outOfRisk.push(0, 101);
    obj.middleRisk.push(-1, -1);
    obj.higherRisk.push(-1, -1);
  } else if (risk.toUpperCase() === 'MIDDLERISK') {
    obj.outOfRisk.push(-1, -1);
    obj.middleRisk.push(0, 100);
    obj.higherRisk.push(-1, -1);
  } else if (risk.toUpperCase() === 'HIGHRISK') {
    obj.outOfRisk.push(-1, -1);
    obj.middleRisk.push(-1, -1);
    obj.higherRisk.push(0, 100);
  }

  return obj;
};

const colorSeverityItem = severety => {
  // condition to define the color as defined in the api
  if (severety == null) {
    return 'gris';
  } else if (severety.toUpperCase() === 'HIGHRISK') {
    return 'red';
  } else if (severety.toUpperCase() === 'OUTOFRISK') {
    return 'green';
  } 
  return 'yellow';
};

const Circular = props => {
  return (
    <div className="container-circular">
      <div className="tour-aux-light-area indicator-tour"/>
      <div className="modal-indicators-info">
        <div className="tour-aux-light-area help-buttons-tour"/>
        <a className="green">
          <i className="fas fa-question-circle" />
          <div>            
            <p>{props.language.summary.behaviour.indicatorHelp1}</p>
            <p>{props.language.summary.behaviour.indicatorHelp2}</p>
            <p>
              <span className="green">
              {props.language.summary.graphTooltip.OUTOFRISK + ": "}
              </span> 
              {props.language.summary.behaviour.between + " " + props.graphColorRange.outOfRisk[0] + " " +  props.language.summary.behaviour.to + " 100"}
            </p>
            <p>
              <span className="yellow">
              {props.language.summary.graphTooltip.MIDDLERISK + ": "}
              </span> 
              {props.language.summary.behaviour.between + " " + (props.graphColorRange.middleRisk[0]+1) + " " +  props.language.summary.behaviour.to + " " + props.graphColorRange.middleRisk[1]}
            </p>
            <p>
              <span className="red">
              {props.language.summary.graphTooltip.HIGHRISK + ": "}
              </span> 
              {props.language.summary.behaviour.between + " " + (props.graphColorRange.higherRisk[0]+1) + " " +  props.language.summary.behaviour.to + " " + (props.graphColorRange.higherRisk[1])}
            </p>
            {props.data.severity!=null && (
              <p>{props.language.summary.behaviour.indicatorHelp3 + " "}
              <span className={colorSeverityItem(props.data.severity)}>{props.language.summary.graphTooltip[props.data.severity.toUpperCase()]}</span></p>
            )}
          </div>
        </a>
      </div>
      <div className="circular-graph-line">
        <div className="box-circular">
          <CircularIndicator
            size={130}
            max={100}
            value={props.data.behaviorGrade}
            forceValue={100}
            fill
            id={'circle1'}
            valueFormat={{ type: 'NUMBER', format: '.0f', sufix: '' }}
            graphColorRange={colorCircular(props.data.severity)}
          />
        </div>
      </div>
      <h3>{props.language.summary.behaviour.indicatorPeriod}</h3>
    </div>
  );
};
export default Circular;



// WEBPACK FOOTER //
// ./source/client/components/summary_behaviour/circular.jsx